<template>
  <div class="loading_wrapper print" v-if="loading">
    <div class="circle"></div>
  </div>
  <div class="sheets">
    <div class="btn-wrapper">
      <button @click="printPreview()">印刷</button>
    </div>
    <div v-if="error_message != ''" class="error-wrapper">
      <p>{{ error_message }}</p>
    </div>
    <div class="sheet-wrapper" v-for="(mansion_data, index) in this.mansions_datas" :key="mansion_data.index">
      <div class="sheet">
        <h1>マンション営業資料</h1>
        <div class="heading-flex">
          <p>マンションデータ</p>
          <p>Hubspot会社ID：</p>
          <p>{{ mansion_data.hs_object_id }}</p>
        </div>
        <table>
          <tr class="cell-2">
            <th>マンション名</th>
            <td>{{ mansion_data.name }}</td>
          </tr>
          <tr class="cell-4">
            <th>ｶﾅ</th>
            <td>{{ mansion_data.mannsixyonnmeikana }}</td>
            <th>担当営業所</th>
            <td>{{ this.nullToEmpty(mansion_data.tantoueigiyoushiyo)}}</td>
          </tr>
          <tr class="cell-4">
            <th>住所</th>
            <td>{{ mansion_data.state }} {{mansion_data.adress}}  {{mansion_data.adres2}}</td>
            <th>営業予定</th>
            <td>{{ this.convertDate(mansion_data.eigiyouteikashiwabara) }}</td>
          </tr>
          <tr class="cell-4">
            <th>管理室TEL</th>
            <td>{{ mansion_data.tel }}</td>
            <th>竣工日</th>
            <td>{{ this.convertDate(mansion_data.shunkoubi1) }}</td>
          </tr>
          <tr class="cell-4">
            <th>前回改修</th>
            <td>{{this.convertDate(mansion_data.zenkaikaishubi) }}</td>
            <th>総会月</th>
            <td>{{ this.dispSoukaiduki(mansion_data.soukaiduki) }}</td>
          </tr>
          <tr class="cell-4">
            <th>任期</th>
            <td>{{ mansion_data.ninki }}</td>
            <th>沿線</th>
            <td>{{ mansion_data.ensen }}</td>
          </tr>
          <tr class="cell-4">
            <th>最寄り駅</th>
            <td>{{ mansion_data.mouorieki }}</td>
            <th>距離</th>
            <td>{{ mansion_data.kiyori }}</td>
          </tr>
          <tr class="cell-4">
            <th>分譲主</th>
            <td>{{ mansion_data.bunjounushi }}</td>
            <th>施工会社</th>
            <td>{{ mansion_data.sekougaisha }}</td>
          </tr>
          <tr class="cell-4">
            <th>管理会社</th>
            <td>{{ mansion_data.kanrigaisiya }}</td>
            <th>管理会社TEL</th>
            <td>{{ mansion_data.telkanrigaishiya }}</td>
          </tr>
          <tr class="cell-2">
            <th>建物概要</th>
            <td>{{ mansion_data.kaisuu }}階{{ mansion_data.tosuu }}戸{{ mansion_data.tousuu }}棟</td>
          </tr>
          <tr class="cell-2">
            <th>備考</th>
            <td>{{ mansion_data.bikou }}</td>
          </tr>
          <tr class="cell-6">
            <th>リピート物件</th>
            <td>{{ this.disp_boolean(mansion_data.repeat___n) }}</td>
            <th>ホット物件</th>
            <td>{{ this.disp_boolean(mansion_data.hotbutukenkashiwabara) }}</td>
            <th>ライフライン物件</th>
            <td>{{ this.disp_boolean(mansion_data.lifelinebutuken) }}</td>
          </tr>
          <tr class="cell-6">
            <th>議事録</th>
            <td>{{ this.disp_boolean(mansion_data.starmaica) }}</td>
            <th>マン暮</th>
            <td>{{ this.disp_boolean(mansion_data.manshiontokurasu) }}</td>
            <th>デイズ紹介</th>
            <td>{{ this.disp_boolean(mansion_data.dayssixyoukai) }}</td>
          </tr>
          <tr class="cell-6">
            <th>理事長名</th>
            <td>{{ mansion_data.rijitixyoumei }}</td>
            <th>部屋番号</th>
            <td>{{ mansion_data.rijitixyouheyabangou }}</td>
            <th>電話番号</th>
            <td>{{ mansion_data.rijitixyoutel }}</td>
          </tr>
          <tr class="cell-6">
            <th>修繕委員長名</th>
            <td>{{ mansion_data.siyuzeniintixyou }}</td>
            <th>部屋番号</th>
            <td>{{ mansion_data.shuzeniinchoheyabangou }}</td>
            <th>電話番号</th>
            <td>{{ mansion_data.shuzeniintixyoutel }}</td>
          </tr>
          <tr class="cell-2"> 
            <th>重要役職者</th>
            <td>{{ mansion_data.kaisixyajixyouhou }}</td>
          </tr>
        </table>
        <p class="subheading">営業状況</p>
        <!-- {{ this.createBizSituation(mansion_data.associations.note_collection__company_to_note.items) }} -->
        <table v-if="mansion_data.associations.note_collection__company_to_note.items.length > 0">
        <!-- <table v-if="mansion_data?.associations?.note_collection__company_to_note?.items?.length > 0"> -->
          <tr class="cell-3">
            <th>コメント日</th>
            <th>内容</th>
            <th>担当者</th>
          </tr>
          
          <tr v-for="comment in mansion_data.associations.note_collection__company_to_note.items[0]" :key="comment.index" class="cell-3">
            <td>{{ this.convertDate(comment.hs_timestamp) }}</td>
            <td>{{ comment.hs_body_preview }}</td>
            <td>{{ this.setUsername(comment.hs_modified_by) }}</td>
          </tr>
        </table>
      </div>
        <!-- <div v-if="mansion_data?.associations?.note_collection__company_to_note?.items?.[1]"> -->
        <div class="sheet" v-for="note in mansion_data.associations.note_collection__company_to_note.items[1]" :key="note.index">

          <h1>マンション営業資料</h1>
          <div class="heading-flex">
            <p></p>
            <p>Hubspot会社ID：</p>
            <p>{{ mansion_data.hs_object_id }}</p>
          </div>
          <p class="subheading">営業状況</p>
          <table>
            <tr class="cell-3">
              <th>コメント日</th>
              <th>内容</th>
              <th>担当者</th>
            </tr>
            
            <tr v-for="comment in note" :key="comment.index" class="cell-3">
              <td>{{ this.convertDate(comment.hs_timestamp) }}</td>
              <td>{{ comment.hs_body_preview }}</td>
              <td>{{ this.setUsername(comment.hs_modified_by) }}</td>
            </tr>
          </table>

        </div>
      <!-- </div> -->
      <div v-if="index !== this.mansions_datas.length - 1" class="break"></div>
      {{ this.clearBizSituation() }}
    </div>
  </div>
  

</template>

<script>
import { API } from 'aws-amplify';
const apiName = "KasiwabaraApp";
const path = "/prints"

const PAGE1_MAX_BYTE = 2300;
const get_formated_time = (
    _fmt = 'YYYYMMDDhhmmss',
    _dt  = new Date(),
) => [
        [ 'YYYY', _dt.getFullYear()  ],
        [ 'MM',   _dt.getMonth() + 1 ],
        [ 'DD',   _dt.getDate()      ],
        [ 'hh',   _dt.getHours()     ],
        [ 'mm',   _dt.getMinutes()   ],
        [ 'ss',   _dt.getSeconds()   ],
    ].reduce(
        (s,a) => s.replace( a[0], `${a[1]}`.padStart(a[0].length,'0') ),
        _fmt
    )

export default {
  data() {
    return {
      companies_id: [],
      mansions_datas: [],
      biz_data1:[],
      biz_data2:[],
      error_message: '',
      owners: sessionStorage.getItem('owners'),
      loading: false,
    }
  },
  computed: {
    setUsername: function() {
      return function (id){
        let username = "";
        JSON.parse((this.owners)).find((owner) => {
          if (owner["userId"] == id) {
            username = owner["lastName"] + owner["firstName"];
            return;
          }
        });
        return username;
      }
    }
    ,createBizSituation: function(){
      return function(notes){
        let page_bytes = 0;
        notes.forEach((note) => {
          page_bytes += note.hs_body_preview.length * 2;
          if (page_bytes < PAGE1_MAX_BYTE){
            this.biz_data1.push(note);
          }else{
            this.biz_data2.push(note);  
          }
        });
        return "";
      }
    }
  },
  mounted() {
    document.title = "マンションデータ_" + get_formated_time();
    const message = JSON.parse(sessionStorage.getItem('key'));
    console.log(message);
    this.companies_id = message;
    this.getData();
  },
  methods: {

    async getData(){
      this.loading = true;
      try{
        let company_ids = [];
        for (let index = 0; index < this.companies_id.length; index++) {
          const id = this.companies_id[index];
          company_ids.push(id);
          if (company_ids.length == 19) {
            await this.getCompanies(company_ids);
            company_ids = [];
          }
        }

        if (company_ids.length > 0){
          await this.getCompanies(company_ids);
        }
         
      }finally{
        this.loading = false;
      }
    },
    async getCompanies(company_ids){
      try{
        let myInit = {
          headers: {"Content-Type": "application/json"},
          response: true
        }
        let sort = (window.opener.document.getElementById("sel_manager").value)? "notes_last_updated__desc": "hs_object_id__asc";

        await API.get(apiName, (path + "?params=" + company_ids + "&sort=" + sort), myInit).then(response => {
            // console.log(response.data.body);
            let res  = JSON.parse(response.data.body);
            res.data.CRM.company_collection.items.forEach(element => {
              this.mansions_datas.push(element);
            });

        }).catch(error => {
            console.log(error)
        });
      }catch{
        console.log("API Error")
      }
    },
    disp_boolean(flag){
      if (flag) {
        return "○"
      }
    },
    printPreview() {
      
      window.print();
    },
    convertDate(dt){
      if (dt == null) return "";
      return (new Date(dt)).toLocaleDateString('ja-JP');
    },
    dispSoukaiduki(soukaiduki) {
      if (soukaiduki == null) return "";
      if (soukaiduki == "0") return "";
      return soukaiduki.includes("月")?soukaiduki:soukaiduki+"月";
    },
    getBytes(str){
      return str.length;
    },
    nullToEmpty(val){
      if (!val) return "";
      return val.label;
    },
    clearBizSituation(){
      this.biz_data1 =[];
      this.biz_data2 =[];

    }
  },
  beforeUnmount() {

  }
}
</script>

<style scoped>
@page {
  size: A4 portrait;
  /* size: landscape; */
  margin: 0;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 12px;
}

tr {
  border-top: 1px solid;
  border-left: 1px solid;
}

tr:nth-last-child(1) {
  border-bottom: 1px solid;
}

th {
  border-right: 1px solid;
  background-color: #EEEEEE !important;
}

td {
  border-right: 1px solid;
  text-align: left;
}

img{
  display: none;
}

.sheets {
  /* margin: 10px 0;
  padding: 60px 0; */
  background: white;
  /* min-height: 100vh; */
}
h1{
  font-size: 20px;
    margin-top: 25px;
  }

.sheet {
  page-break-after: always;
  height: 277mm;
  width: 197mm;
  padding: 5mm;
  background: white;
  box-shadow: 0 .5mm 2mm rgba(0, 0, 0, .3);
  margin: 10mm auto;
}

.sheet:last-child {
  page-break-after: auto;
}

.sheet tr {
  display: inline-flex;
  width: 100%;
}

.heading-flex {
  display: flex;
}

.heading-flex p:nth-child(2) {
  margin-left: auto;
}
th{
  display: flex;
  align-items: center;
  justify-content: center;
}
.cell-2 th,
.cell-4 th {
  width: 20%;
}

.cell-2 td {
  width: 80%;
}

.cell-4 td {
  width: 30%;
}

.cell-6 th {
  width: 20%;
}

.cell-6 td {
  width: 13.33%;
}

.cell-3 th:nth-child(1),
.cell-3 th:nth-child(3),
.cell-3 td:nth-child(1),
.cell-3 td:nth-child(3) {
  width: 15%;
}

.cell-3 th:nth-child(2),
.cell-3 td:nth-child(2) {
  width: 70%;
}

.btn-wrapper {
  width: 287mm;
  margin: 0 auto;
  text-align: left;
}

.btn-wrapper button {
  color: #fff;
  background: #003399;
  padding: 10px 20px;
  border-radius: 4px;
  border: none;
  transition: 0.5s;
}

.btn-wrapper button:hover {
  background: #003366;
  transition: 0.5s;
}

.subheading {
  margin-top: 30px;
  text-align: left;
}
.error-wrapper{
  width: 287mm;
  margin: 30px auto 0;
  border: 1px solid;
  padding: 30px;
  background: #fff;
  border-radius: 8px;
}

@media print {
  /* .sheets> :not(.sheet) {
    display: none;
  } */
  .btn-wrapper{
    display:none;
  }
  .error-wrapper{
    display: none;
  }

  .break {
    break-before: page;
  }

  .sheets {
    /* margin-top: -60px; */
    padding: 0;
    width: 210mm;
	height: 297mm;
  }

  .sheet {
    margin: 0 auto;
    padding: 0;
    box-shadow: none;
  }
}
</style>
<style>
body {
  margin: 0 !important;
  -webkit-print-color-adjust: exact;
}

button:hover {
  cursor: pointer;
}

.loading_wrapper{
  position: absolute;
  width: 100vw;
  background: black;
  opacity: 0.33;  
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.loading_wrapper.print{
  top:500px;
}

.circle{
  width:200px;
  height:200px;
  border-radius:150px;
  border:15px solid #fff;
  border-top-color:rgba(0,0,0,0.3);
  box-sizing:border-box;
  position:absolute;

  animation:circle 1s linear infinite;
  -webkit-animation:circle 1s linear infinite;
}
@keyframes circle{
  0%{transform:rotate(0deg)}
  100%{transform:rotate(360deg)}
}
@-webkit-keyframes circle{
  0%{-webkit-transform:rotate(0deg)}
  100%{-webkit-transform:rotate(360deg)}
}
</style>